import {
  GET_ALERTS,
  GET_ALERTS_START,
  GET_ALERTS_SUCCESS,
  GET_ALERTS_FAIL,
  GET_ALERTS_FETCH_MORE,
  GET_ALERTS_FETCH_MORE_START,
  GET_ALERTS_FETCH_MORE_SUCCESS,
  GET_ALERTS_FETCH_MORE_FAIL,
  GET_ALERTS_COUNT,
  GET_ALERTS_START_COUNT,
  GET_ALERTS_SUCCESS_COUNT,
  GET_ALERTS_FAIL_COUNT,
} from 'actions/alerts';

import { getListPageSuccessNewDataBQSupport } from '../utils';

export const defaultState = {
  error: false,
  loading: true,
  loadingCount: true,
  alerts: {},
};

export default function groupPerformance(state = defaultState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_ALERTS:
    case GET_ALERTS_START: {
      return {
        ...state,
        alerts: {},
        error: false,
        loading: true,
      };
    }
    case GET_ALERTS_FETCH_MORE:
    case GET_ALERTS_FETCH_MORE_START: {
      return {
        ...state,
        error: false,
        loading: true,
      };
    }
    case GET_ALERTS_SUCCESS:
    case GET_ALERTS_FETCH_MORE_SUCCESS: {
      return {
        ...state,
        error: false,
        loading: false,
        alerts: {
          ...payload,
          data: getListPageSuccessNewDataBQSupport(
            state.alerts,
            payload.data,
            payload.links,
          ),
          total: state.alerts?.total ?? undefined,
        },
      };
    }
    case GET_ALERTS_FAIL:
    case GET_ALERTS_FETCH_MORE_FAIL: {
      return {
        ...state,
        alerts: {},
        error: payload.json,
        loading: false,
      };
    }
    case GET_ALERTS_COUNT:
    case GET_ALERTS_START_COUNT: {
      return {
        ...state,
        error: false,
        loadingCount: true,
      };
    }
    case GET_ALERTS_SUCCESS_COUNT: {
      return {
        ...state,
        error: false,
        loadingCount: false,
        alerts: {
          ...state.alerts,
          total: payload.total,
        },
      };
    }
    case GET_ALERTS_FAIL_COUNT: {
      return {
        ...state,
        error: payload.json,
        loadingCount: false,
        total: undefined,
      };
    }
    default:
      return state;
  }
}
